import { ReactElement } from 'react';
import { Machine } from '../../api/graphql/generated';
import { useHasFeature } from '../../api/hooks/feature.hooks';
import { ContentLoading } from '../loading/content-loading';
import { ApplicationsCard } from './cards/applications-card';
import { EventsCard } from './cards/events-card';
import { FilesCard } from './cards/files-card';
import { MachineInfoCard } from './cards/machine-info-card';
import { MachineMaintenanceCard } from './cards/machine-maintenance-card';
import { MachineRealtimeCard } from './cards/machine-realtime-card';
import './machine.css';
export interface MachineConfigProps {
  machine?: Machine;
  hideMaintenance?: boolean;
  hideFiles?: boolean;
  hideRealtime?: boolean;
  hideEvents?: boolean;
  hideApplications?: boolean;
}

const MachineConfig = (props: MachineConfigProps): ReactElement => {
  const {
    machine,
    hideMaintenance,
    hideFiles,
    hideRealtime,
    hideEvents,
    hideApplications,
  } = props;

  const canAssignApplicationLicenses = useHasFeature<boolean | undefined>(
    'beacon-assign-application-license'
  );

  if (!machine) {
    return <ContentLoading />;
  }

  return (
    <div className="machine-list-container">
      <div className="machine-list-spacing">
        <MachineInfoCard machine={machine} />
      </div>
      <>
        {!hideMaintenance && (
          <div className="machine-list-spacing">
            <MachineMaintenanceCard machine={machine} />
          </div>
        )}
        {!hideFiles && (
          <div className="machine-list-spacing">
            <FilesCard machine={machine} />
          </div>
        )}
        {!hideRealtime && (
          <div className="machine-list-spacing">
            <MachineRealtimeCard machine={machine} />
          </div>
        )}
        {!hideEvents && (
          <div className="machine-list-spacing">
            <EventsCard machine={machine} />
          </div>
        )}
        {!hideApplications && canAssignApplicationLicenses && (
          <div className="machine-list-spacing">
            <ApplicationsCard machine={machine} />
          </div>
        )}
      </>
    </div>
  );
};

export { MachineConfig };
